export default __webpack_public_path__ + "static/media/photo-icon-white.0e31787f.svg";